import React from 'react';
import moment from 'moment';
import { Typography } from '@material-ui/core';
import globals from '../../../globals/communityGlobals';
import { lowerFirstLetter } from '../../../utils/helpers';

const locale = globals.getArea('audit');
const eventTypeLocale = globals.getArea('eventType');
export const tableSettings = () => {
  return {
    name: <Typography variant="h3">{locale.getMsg('auditTrail')}</Typography>,
    columns: [
      {
        name: 'eventType',
        label: locale.getMsg('auditEventType'),
        options: {
          sort: false,
          setCellProps: () => ({
            style: { minWidth: 200 },
          }),
          customBodyRender: value => {
            return eventTypeLocale.getMsg(lowerFirstLetter(value));
          },
        },
      },
      {
        name: 'userLogin',
        label: locale.getMsg('user'),
        options: {
          sort: false,
          setCellProps: () => ({
            style: { minWidth: 200 },
          }),
        },
      },
      {
        name: 'createdDate',
        label: locale.getMsg('dateTime'),
        options: {
          sort: false,
          setCellProps: () => ({
            style: { minWidth: 200 },
          }),
          customBodyRender: value => <span>{moment(value).format(globals.dateFormats.shortWithTime)}</span>,
        },
      },
    ],
    options: {
      responsive: 'standard',
      selectableRows: 'none',
      print: true,
      search: false,
      filter: false,
      serverSide: true,
      pagination: false,
    },
  };
};
